<!-- <table class="table table-bordered" id="dataTabled" width="100%" cellspacing="0">
  <thead>
    <tr>
      <th>Tên Nhà Xuất Bản</th>
      <th>Hành Động</th>
    </tr>
  </thead>
  <tfoot>
    <tr>
      <th>Tên Nhà Xuất Bản</th>
      <th>Hành Động</th>
    </tr>
  </tfoot>
  <tbody>
    <tr *ngFor="let t of publishers">
      <td>{{ t.name }}</td>
      <td>
       
        <div class="dropdown">
          <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Hành Động
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" href="#" data-toggle="modal" (click)="edit(t.id)" data-target="#edit">
              <i class="fas fa-edit"></i> Chỉnh Sửa
            </a>
            <a class="dropdown-item" href="#" (click)="delete(t.id)">
              <i class="fas fa-trash-alt"></i> Xóa
            </a>
            <a class="dropdown-item" href="#" data-toggle="modal" data-target="#exampleModal">
              <i class="fas fa-eye"></i> Xem Chi Tiết
            </a>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Thông Tin Nhà Xuất Bản</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Đóng">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <table class="table">
                  <tr>
                      <th>Id</th>
                      <td>7013735</td>
                  </tr>
                  <tr>
                      <th>Nickname</th>
                      <td>Page, Elliot</td>
                  </tr>
                  <tr>
                      <th>Name</th>
                      <td>Page, Elliot</td>
                  </tr>
                  <tr>
                      <th>Bio</th>
                      <td></td> 
                  </tr>
                  <tr>
                      <th>Publications</th>
                      <td></td> 
                  </tr>
                  <tr>
                      <th>Country</th>
                      <td></td> 
                  </tr>
                  <tr>
                      <th>Awards</th>
                      <td></td> 
                  </tr>
                  <tr>
                      <th>Image</th>
                      <td></td> 
                  </tr>
                  <tr>
                      <th>References</th>
                      <td></td> 
                  </tr>
                  <tr>
                      <th>Date Of Birth</th>
                      <td></td> 
                  </tr>
                  <tr>
                      <th>Year Died</th>
                      <td></td> 
                  </tr>
                  <tr>
                      <th>User Id</th>
                      <td>227457</td>
                  </tr>
                  <tr>
                      <th>Library Id</th>
                      <td>60598</td>
                  </tr>
                  <tr>
                      <th>Created</th>
                      <td>2024-06-05 07:36:47</td>
                  </tr>
                  <tr>
                      <th>Modified</th>
                      <td>2024-06-05 07:36:47</td>
                  </tr>
              </table>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Đóng</button>
              
          </div>
      </div>
  </div>
</div> -->


<ngx-datatable
  class="bootstrap"
  [rows]="publishers"
  [columnMode]="'force'"
  [headerHeight]="50"
  [footerHeight]="50"
  [rowHeight]="'auto'"
  [limit]="10"
  [loadingIndicator]="loading"
  [reorderable]="reorderable"
  (select)="onSelect($event)"
  (activate)="onActivate($event)"
>

  <!-- ID Column -->
  <ngx-datatable-column name="ID" [prop]="'id'">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.id }}
    </ng-template>
  </ngx-datatable-column>

  <!-- Publisher Name Column -->
  <ngx-datatable-column name="Publisher Name" [prop]="'name'">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.name }}
    </ng-template>
  </ngx-datatable-column>

  <!-- Address Column -->
  <ngx-datatable-column name="Address" [prop]="'address'">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.address }}
    </ng-template>
  </ngx-datatable-column>

  <!-- Email Column -->
  <ngx-datatable-column name="Email" [prop]="'email'">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.email }}
    </ng-template>
  </ngx-datatable-column>

  <!-- Phone Column -->
  <ngx-datatable-column name="Phone" [prop]="'phone'">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.phone }}
    </ng-template>
  </ngx-datatable-column>

  <!-- Country Column -->
  <ngx-datatable-column name="Country" [prop]="'country'">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.country }}
    </ng-template>
  </ngx-datatable-column>

  <!-- Website Column -->
  <ngx-datatable-column name="Website" [prop]="'website'">
    <ng-template ngx-datatable-cell-template let-row="row">
      <a [href]="row.website" target="_blank">{{ row.website }}</a>
    </ng-template>
  </ngx-datatable-column>

  <!-- Actions Column -->
  <ngx-datatable-column name="Actions">
    <ng-template ngx-datatable-cell-template let-row="row">
      <button class="btn btn-sm btn-outline-primary mr-2" (click)="openEditDialog(row)">
        Edit
      </button>
     <!--  <button class="btn btn-sm btn-danger" (click)="deleteRow(row)">
        Delete
      </button> -->
    </ng-template>
  </ngx-datatable-column>

</ngx-datatable>
